import { action, observable, computed } from 'mobx';
import { post } from '../../../services/request';

export default class WhitelistingStore {
  @observable vm = undefined;

  @computed get whitelist() {
    return Object.keys(this.vm.whitelist).map((k) => this.vm.whitelist[k]);
  }

  @computed get pendingRequests() {
    const vm = this.vm;
    if (!vm) return 0;
    return Object.keys(vm.whitelist).filter(
      (k) => vm.whitelist[k].status === 'requested'
    ).length;
  }

  constructor({ root }) {
    this.root = root;
  }

  @action update(data) {
    this.vm = data;
  }

  @action reset() {
    this.vm = undefined;
  }

  @action async accept({ userId, saleId }) {
    const res = await post(
      `/api/v1/sales/${saleId || this.root.saleId}/whitelist`,
      { userId },
      this.root.user.accessToken
    );
    return res && res.result && res.result.successful;
  }

  @action async block({ userId, saleId, reason }) {
    const res = await post(
      `/api/v1/sales/${saleId || this.root.saleId}/whitelist/block`,
      { userId, reason },
      this.root.user.accessToken
    );
    return res && res.result && res.result.successful;
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/WhitelistingStore.js